const parseDateToISOFormat = (value, USAFormat = false) => {
    const day = value.getDate().toString().padStart(2, '0'),
        month = (value.getMonth() + 1).toString().padStart(2, '0'),
        year = value.getFullYear()

    if (USAFormat) {
        return `${month}/${day}/${year}`
    }
    return `${day}/${month}/${year}`
}

const isMobile = () => {
    const viewWidth = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
    )

    return viewWidth < 992
}

export { parseDateToISOFormat, isMobile }
